var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModeClassic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=Daily"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    cx: 40,
    cy: 40,
    r: 40,
    fill: "url(#paint0_linear_2850_27)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "head",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6166 41.7524L60.7712 30.0919C57.4649 20.737 50.326 13.8151 40.4629 13.5906C28.7041 13.3229 19.0001 22.5404 18.8694 34.3016C18.7977 40.7661 21.5922 46.5551 26.0663 51.0843C26.8965 51.9247 27.1482 53.1775 26.6989 54.2702L24.8468 58.7782C24.7364 59.0472 24.8474 59.3561 25.104 59.4931L28.3211 61.2094L36.4386 41.3403L38.1388 37.1863H25.4289C24.105 37.195 23.0277 36.1241 23.0277 34.8005C23.0277 25.7436 30.0736 18.1135 39.1215 17.709C48.7892 17.2773 56.7627 24.9873 56.7627 34.5594V34.766C56.7627 36.1029 55.679 37.1863 54.3424 37.1863H44.8196V37.1869C43.2928 37.1669 41.9075 38.0775 41.32 39.487L31.58 62.948L41.7919 68.396C42.0866 68.5533 42.4526 68.4226 42.5809 68.1141L47.8301 55.5061L53.9612 55.5039C58.8846 55.4428 59.6531 54.4932 59.6531 49.3731V42.5393L65.0938 42.5359C65.4977 42.5356 65.7715 42.1251 65.6166 41.7524Z",
    fill: "#FCFAF4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shimmer",
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8355 17.6919C30.5133 17.724 23.0275 25.4201 23.0275 34.7426V34.8004C23.0275 36.1243 24.1051 37.195 25.4287 37.1862H38.1389L45.6834 18.7112L45.478 18.6416C43.7125 18.0223 41.8144 17.6853 39.8355 17.6919Z",
    fill: "#FCFAF4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2850_27",
    x1: 66,
    y1: -0.00000155787,
    x2: 30.9333,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD6533"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeClassic);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default MemoForwardRef;